// Merchant Sales Report (MM-3037): API shapes of reports/merchant-sales/{summary,children,search}.

export type MerchantType = "MDST" | "DST" | "SDST" | "AGT" | "RET";

export const MERCHANT_TYPE_LABELS: Record<MerchantType, string> = {
  MDST: "Master Distributor",
  DST: "Distributor",
  SDST: "Sub-Distributor",
  AGT: "Agent",
  RET: "Retailer",
};

export interface Mno {
  id: string;
  name: string;
}

/** Amounts are integer puls (AFA x 100); `amounts` is aligned with the response's `mnos`. */
export interface Figures {
  amounts: number[];
  /** Total recharge sales: the sum of `amounts`, computed by the backend. */
  total: number;
  /** Total stock sales, not part of `total`. */
  stock_sales: number;
}

export interface MerchantRow {
  id: string;
  parent_id: string | null;
  user_type: MerchantType;
  user_code: string;
  name: string;
  parent_name: string | null;
  parent_code: string | null;
  depth: number;
  child_count: number;
  /** The merchant alone: what its row shows. */
  own: Figures;
  /** The merchant plus all its direct and indirect children: only its Σ Subtotal row. */
  subtree: Figures;
}

export interface SummaryData {
  data_as_of: string | null;
  mnos: Mno[];
  merchant: MerchantRow | null;
  grand_total: Figures | null;
}

export interface ChildrenPage {
  items: MerchantRow[];
  next_cursor: string | null;
  has_more: boolean;
  total_count: number;
}

export interface MerchantOption {
  id: string;
  user_code: string;
  name: string;
  user_type: MerchantType;
}

/** Inclusive Kabul calendar days, YYYY-MM-DD. */
export interface DateRange {
  start: string;
  end: string;
}
